<p-toast key="top-right" [baseZIndex]="99999"></p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>

        <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
    </div>
    <div class="layout-topbar-menu-section">
        <app-sidebar></app-sidebar>
    </div>
    <div class="topbar-end">
        <ul class="topbar-menu">
            <!-- <li class="hidden lg:block">
                <div class="topbar-search" [ngClass]="{'topbar-search-active': searchActive}">
                    <button pButton icon="pi pi-search" class="topbar-searchbutton p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0" type="button" (click)="activateSearch()"></button>
                    <div class="search-input-wrapper">
                        <span class="p-input-icon-right">
                            <input #searchinput type="text" pInputText placeholder="Search" (blur)="deactivateSearch()" (keydown.escape)="deactivateSearch()"/>
                            <i class="pi pi-search"></i>
                        </span>
                    </div>
                </div>
            </li> -->
           
            <!-- <li  class="profile-item topbar-item " >
                <button pButton type="button" icon="pi pi-bell" class="p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0"></button>
            </li> -->

            <!-- <li  class="profile-item topbar-item " >
                <button pButton type="button" icon="pi pi-comment"  class="p-button-text p-button-secondary relative text-color-secondary p-button-rounded flex-shrink-0"></button>
            </li> -->
            <li class="m-0 mb-3 pt-3" *ngIf="!impresoraStatus">
                <a (click)="seleccionarImpresoraBluetooth()" class="flex align-items-center hover:text-primary-500" pStyleClass="@grandparent" enterFromClass="ng-hidden" 
                    enterActiveClass="px-scalein" style="cursor: pointer;" [pTooltip]="mostrarIconoImpresora ? 'Conectar impresora' : ''"  tooltipPosition="right">
                    <i class="pi pi-fw pi-print mr-2"></i>
                    <span *ngIf="!mostrarIconoImpresora" class="tooltip-text" style="display: inline;">Conectar impresora</span>
                </a>
            </li>
            <li class="m-0 mb-3 pt-3" *ngIf="impresoraStatus">
                <a (click)="desconectarImpresoraBluetooth()" class="flex align-items-center hover:text-primary-500" pStyleClass="@grandparent" enterFromClass="ng-hidden" 
                    enterActiveClass="px-scalein" style="cursor: pointer;" [pTooltip]="mostrarIconoImpresora ? 'Impresora Conectada' : ''"  tooltipPosition="right">
                    <i class="pi pi-fw pi-print mr-2"></i>
                    <span *ngIf="!mostrarIconoImpresora" class="tooltip-text" style="display: inline;">Impresora conectada</span>
                </a>
            </li>
            <li class="ml-3">
                <button pButton type="button" icon="pi pi-cog" class="p-button-text p-button-secondary text-color-secondary p-button-rounded flex-shrink-0" (click)="onConfigButtonClick()"></button>
            </li>

            <li #profile class="profile-item topbar-item" >
                <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple class="cursor-pointer">
                    <!-- <img class="border-circle" src="assets/demo/images/avatar/square/avatar-m-1.jpg"> -->
                    <p-avatar [label]="iniciales" shape="circle" size="large" styleClass="ml-2"></p-avatar>
                </a>

                <ul class="topbar-menu active-topbar-menu p-4 w-15rem z-5 ng-hidden border-round">
                    <li role="menuitem" class="m-0 mb-3">
                        <a class="flex align-items-center hover:text-primary-500 transition-duration-200" pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <!-- <i class="pi pi-fw pi-lock mr-2"></i> -->
                            <span>{{ currentUser.nombre }}</span>
                        </a>
                    </li>
                    <hr>
                    <li role="menuitem" class="m-0 mb-3">
                        <a (click)="cambiarContrasenha()" class="flex align-items-center hover:text-primary-500 transition-duration-200" pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="pi pi-fw pi-key mr-2"></i>
                            <span>Cambiar Contraseña</span>
                        </a>
                    </li>
                    <li role="menuitem" class="m-0">
                        <a (click)="salir()" class="flex align-items-center hover:text-primary-500 transition-duration-200" pStyleClass="@grandparent" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout">
                            <i class="pi pi-fw pi-sign-out mr-2"></i>
                            <span>Salir</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="right-panel-button relative hidden lg:block">
                <button pButton  type="button" label="Hoy" style="width:5.7rem" icon="pi pi-bookmark" 
                class="layout-rightmenu-button hidden md:block font-normal" styleClass="font-normal" (click)="onSidebarButtonClick()"></button>
                <button pButton type="button" icon="pi pi-bookmark" styleClass="font-normal" class="layout-rightmenu-button block md:hidden" (click)="onSidebarButtonClick()"></button>
            </li>
        </ul>
    </div>
</div>


<p-dialog [(visible)]="showDialogPassword" position="center" [modal]="true" header="Cambiar Contraseña" [breakpoints]="{'960px': '75vw', '400px': '95vw'}" [style]="{width: '50vw'}" [closeOnEscape]="false" [closable]="false" >
    <div class="grid">
        <div class="col-12">
            <p><b>Recomendaciones</b></p>
            <p>1. Por su seguridad trate que la contraseña tenga alguna letra mayúscula, minúscula, numero y/o algun caracter especial.</p>
            <p>2. Evite fechas de nacimiento, su propio nombre o codigo de usuario.</p>
            <p>3. Evite numeros consecutivos. Ej: 123456.</p>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="confirmarPass()" >
                <div class="p-fluid p-formgrid grid flex align-items-center flex-wrap">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="oldPassword">Contraseña Anterior</label>
                        <span class="p-input-icon-right">
                            <input pInputText [type]="passType" id="oldPassword" type="text" formControlName="oldPassword" />
                            <i *ngIf="passType==='password'" style="font-size: 1.2rem;" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" style="font-size: 1.2rem;" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="password1">Nueva Contraseña</label>
                        <span class="p-input-icon-right">
                            <input pInputText [type]="passType" id="password1" type="text" formControlName="password1" />
                            <i *ngIf="passType==='password'" style="font-size: 1.2rem;" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" style="font-size: 1.2rem;" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="password2">Repetir Contraseña</label>
                        <span class="p-input-icon-right">
                            <input pInputText [type]="passType" id="password2" type="text" formControlName="password2" />
                            <i *ngIf="passType==='password'" style="font-size: 1.2rem;" class="pi pi-lock" (click)="showPassword('text')"></i>
                            <i *ngIf="passType==='text'" style="font-size: 1.2rem;" class="pi pi-lock-open" (click)="showPassword('password')"></i>
                        </span>
                    </div>
                </div>
                <hr>
                <div class="p-fluid p-formgrid grid flex align-items-center flex-wrap">
                    <div class="field col-12 md:col-6">
                        <button *ngIf="mostrarBtnCancelar" pButton pRipple type="button" icon="pi pi-times" class="p-button-warning" label="Cancelar" (click)="cancelarPass()"></button>
                    </div>
                    <div class="field col-12 md:col-6">
                        <button pButton pRipple type="submit" icon="pi pi-check" label="Confirmar"></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</p-dialog>

